import { bindDocumentNavigationToActiveAccountWhenBackgrounded } from '#pplx/frontend/browser-storage/accountNavigation.js';
import { sanitizedRedirectWindow } from '#pplx/frontend/common/sanitizedRedirectWindow.js';
import { logger } from '#pplx/frontend/logger/browser.js';
/**
 * Redirects the window to the given URL.
 * Same site only due to risk of XSS.
 * @param url - The URL to redirect to.
 * @param reason - The reason for the redirect.
 */
export function redirectWindow(url, reason) {
    const accountBoundUrl = bindDocumentNavigationToActiveAccountWhenBackgrounded(url);
    logger.info('Redirecting window', {
        reason,
        url: window.location.href,
        redirect: accountBoundUrl,
    });
    sanitizedRedirectWindow(accountBoundUrl);
}
//# sourceMappingURL=redirectWindow.js.map